(function () {
  function formatMoney(cents) {
    if (typeof Shopify !== 'undefined' && Shopify.formatMoney) {
      return Shopify.formatMoney(
        cents,
        Shopify.money_format || '${{amount}}'
      );
    }
    return (cents / 100).toFixed(2);
  }

  document.addEventListener('click', function (event) {
    const checkoutButton = event.target.closest('[data-cart-checkout]');
    if (!checkoutButton) return;

    const wrapper = checkoutButton.closest('[data-cart-minimum-wrapper]');
    if (!wrapper) return;

    // Stop the normal submit – we’ll decide what to do
    event.preventDefault();

    const minValue = parseInt(wrapper.dataset.minimumOrder || '0', 10) || 0;
    const minMoney = wrapper.dataset.minimumMoney || formatMoney(minValue);
    const checkoutUrl = wrapper.dataset.checkoutUrl || '/checkout';
    const messageEl = wrapper.querySelector('[data-cart-minimum-message]');

    fetch('/cart.js')
      .then(function (response) { return response.json(); })
      .then(function (cart) {
        var total = cart.total_price || 0;

        if (total < minValue) {
          var diff = minValue - total;
          var diffText = formatMoney(diff);

          if (messageEl) {
            messageEl.textContent =
              'Minimum order value is ' + minMoney +
              '. Add ' + diffText + ' more to proceed to checkout.';

            messageEl.classList.add('cart__message--error');
            messageEl.setAttribute('role', 'alert');
          }

          wrapper.classList.add('cart-minimum--blocked');

          // Smooth scroll to the message so the customer sees it
          if (messageEl && typeof messageEl.scrollIntoView === 'function') {
            messageEl.scrollIntoView({ behavior: 'smooth', block: 'center' });
          }
        } else {
          // ✅ Minimum reached – go directly to checkout
          window.location.href = checkoutUrl;
        }
      })
      .catch(function () {
        // If cart check fails, don't block checkout
        window.location.href = checkoutUrl;
      });
  });
})();
